import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_ENDPOINT;

export const fetchGetOffer = createAsyncThunk(
  "get-offer",
  async (_, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.get(`${API_URL}/get-offer`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      return response.data.data.data;
    } catch (error) {
      console.error("Error fetching get offer data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch get offer data"
      );
    }
  }
);

const getOfferSlice = createSlice({
  name: "getOffer",
  initialState: {
    get_offer: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetOffer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchGetOffer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.get_offer = action.payload;
      })
      .addCase(fetchGetOffer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default getOfferSlice.reducer;
